import { Award as AwardModel } from '../../../awards/shared';

export class Award {
  _id?: string;
  award: AwardModel;
  url: string = '';
  review: string = '';
  position: number = 0;
  locale: string = '';
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/award.model.ts